import { Location } from '../GoogleMap.types';

type Link = Location['link'];

export const getLinkObject = (url: string): any => {
  return {
    url,
    type: 'ExternalLink',
    target: '_blank',
  };
};
